import { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

type ControlButtonProps = {
  onClick: () => void
  icon: ReactNode
  label: string
}

export const ControlButton = ({ onClick, icon, label }: ControlButtonProps) => {
  return (
    <Button
      onClick={onClick}
      variant="ghost"
      size="sm"
      className="flex flex-col w-16 h-16 [&_svg]:w-7! [&_svg]:h-7!"
      title={label}
    >
      {icon}
      <span className="text-xs font-bold">{label}</span>
    </Button>
  )
}
